import { useNavigate } from "flemo";
import { SettingsIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

import { SearchBar } from "./SearchBar";

type HeaderProps = {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
};

export function Header({ searchQuery, onSearchQueryChange }: HeaderProps) {
  const { push } = useNavigate();

  return (
    <header className="px-5 pt-2 pb-4 shrink-0 flex flex-col gap-3 w-full mx-auto max-w-4xl">
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <h1 className="text-3xl font-extrabold text-white">CATEGORIES</h1>
          <p className="text-sm text-white/70">연습할 세트를 선택하세요</p>
        </div>

        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="설정"
          onClick={() => {
            void trackEvent("settings_opened", { source: "flashcards" });
            push("/settings");
          }}
        >
          <SettingsIcon className="size-5 text-white/70" />
        </Button>
      </div>

      <SearchBar query={searchQuery} onQueryChange={onSearchQueryChange} />
    </header>
  );
}
